import React, { useRef, useState } from "react";

import Carrers4 from "../images/Careers4.png";
import email from "../images/email.png";
import backimg from "../../new_Images/OtherComponents/15.png";
import CARRERVIDEO from "../../videos/CareerAtClota1.gif";
import Carrersimg from "../../videos/CarrersimgN1.jpg";
import { Button } from "primereact/button";

import "../../App.css";

import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { Helmet } from "react-helmet";

function Careers() {
  const mediaRef = useRef();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <>
      <Helmet>
        <title>Careers at CLOTA Technology | Join Our Team</title>
        <meta
          name="description"
          content="Explore career opportunities at CLOTA Technology. Join a fast-growing IT team that values innovation, teamwork, and growth."
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="CLOTA Technology careers, IT jobs, join CLOTA, tech jobs, software jobs"
        />
 <meta name="robots" content="index, follow" />
  <meta name="author" content="Clota Technology" />
  <link rel="canonical" href="https://www.clotatech.com/Careers" />
      </Helmet>

      {/* Banner */}
      {/* <div>
        <img src={backimg} className="w-full homebanner" alt="Responsive" />
      </div> */}

      <div className="banner-container">
        <img src={backimg} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Let’s get started</h1>
            <p>
Apply Now!
            </p>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="mt-5 px-5 py-2">
        <div className="grid">
          <div className="col-12 md:col-6">
            <div
              className="Text-Gradient mt-3"
              style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}
            >
              <h3>
              <b>
                <i>Career in Clota</i>
              </b>
            </h3>
            </div>

            <div className="homepara">
              <i>
                <p>
                  At CLOTA, we prioritize getting IT projects right the first
                  time, on time, and within budget. We're growing rapidly and
                  seek passionate, self-motivated individuals. Our organization
                  values both people and clients, ensuring a diverse, inclusive,
                  and accessible workplace.
                </p>
                <p className="mbr-text mbr-fonts-style display-7">
                  Accelerate your career in a high-performance environment.
                </p>
                <p className="position mbr-fonts-style display-4">
                  <a
                    href="mailto:support@clotatechnology.com"
                    className="text-primary"
                    // style={{ fontSize: "40px" }}
                  >
                    <strong
                      style={{ fontFamily: "rockwell", fontSize: "35px" }}
                      className="Text-Gradient"
                    >
                      Join our alumni circle to stay in touch.
                    </strong>
                  </a>
                </p>
              </i>
            </div>
          </div>

          <div className="col-12 md:col-6 flex justify-content-center">
            <img
              src={Carrers4}
              alt="Career Illustration"
              className="w-full"
              style={{ maxWidth: "420px", marginTop: "7rem" }}
            />
          </div>
        </div>
      </div>

      {/* How We Help Section */}
      
      
      <div
        className="mt-5 px-5 py-2 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h1 className="m-5">
           <b>This is How Clota Technology Help You!</b>
        </h1>
      </div>


      <div className="mt-5 px-5 py-2">
        <div className="grid">
          <div className="col-12 md:col-6">
            <h3 className="Text-Gradient" style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}>
              <b>
                <i>Team Work</i>
              </b>
            </h3>
            <p>
              <i>
                Teamwork makes all kinds of tasks easier and faster. Big or
                difficult undertakings, on the other hand, necessitate teamwork
                more than speed or convenience.
              </i>
            </p>

            <h3
              className="Text-Gradient mt-4"
              style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}
            >
              <b>
                <i>Unity</i>
              </b>
            </h3>
            <p>
              <i>
                Unity the word for togetherness or oneness. By being together or
                at one with someone or something. Clota Technology Can Achieve
                Anything!
              </i>
            </p>

            <h3
              className="Text-Gradient mt-4"
              style={{ fontFamily: "rockwell", fontSize:"1.3rem" }}
            >
              <b>
                <i>Get Help</i>
              </b>
            </h3>
            <p>
              <i>
                Don’t let a career-break break your career. We learn, disrupt,
                and grow together at Clota! With us, you can explore your career
                options.
              </i>
            </p>
          </div>

          <div className="col-12 md:col-6 flex justify-content-center">
            <div className="text-center">
              <p className="font-medium">Hover To Play</p>
              <img
                ref={mediaRef}
                title="hover to play"
                src={isHovered ? CARRERVIDEO : Carrersimg}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                alt="Career GIF"
                className="rounded shadow-2"
                style={{ height: "50vh", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Advantages Section */}
      <div className="mt-5 px-5 py-2">
        <div className="grid">
          <div className="col-12 md:col-6">
            
      <div
        className="mt-5 px-5 py-2 Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h1 >
              <b>Advantages of Clota</b>
        </h1>
      </div>

            <i>
              <ul className="list-none p-0">
                <li className="mb-2">
                  <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                  Benefits to Your Career of Working for a Growing Organization.
                </li>
                <li className="mb-2">
                  <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                  Comprehensive benefits for workers.
                </li>
                <li className="mb-2">
                  <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                  Diverse and Difficult Projects.
                </li>
                <li className="mb-2">
                  <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                  Competitive Compensation.
                </li>
                <li className="mb-2">
                  <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                  Excellent Learning Possibilities.
                </li>
              </ul>
            </i>
          </div>

          <div className="col-12 md:col-6 flex justify-content-center align-items-center mt-5">
            <img
              src={email}
              alt="email"
              className="rounded"
              style={{ maxHeight: "220px" }}
            />
          </div>
        </div>
      </div>

      {/* Apply Now Button */}
      <div className="text-center mt-4 mb-4">
        <a
          href="mailto:support@clotatechnology.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            label="Apply Now"
            className="btn-styles btn"
            style={{
              fontFamily: "rockwell",
              fontSize: "24px",
              padding: "1rem 2rem",
            }}
          />
        </a>
      </div>
    </>
  );
}

export default Careers;
